export default {
  id: 139,
  title: 'Target #139 - Lamp',
  url: 'https://cssbattle.dev/play/139',
  colors: ['#E38F66', '#FFFBDA', '#62306D'],
  solution:
    '<a a><a b><style>body{background:#e38f66}a{position:fixed}[a]{top:90;left:137;width:127;height:120;background:#fffbda;clip-path:polygon(32px 0,94px 0,126px 120px,0 120px)}[b]{bottom:0;left:195;width:10;height:90;background:#62306d}</style>',
}
